'use strict';

module.exports = {
    STATE_UPDATE: 'file.transfers.state.updated',
    TOUCHED: 'file.transfers.touched'
};